import * as React from 'react'
import { IAssistanceObject, IMap } from '../../types'
import { IAssistanceCategoryObject, IStoreState } from '../../types/index'
import AssistanceListItem from './AssistanceListItem'

interface IAssistanceItemProps {
  assistances: IMap<IAssistanceObject>
  categories: IMap<IAssistanceCategoryObject>
  onRemove: (assistance: IAssistanceObject) => void
}

const getCategory = (categories: IMap<IAssistanceCategoryObject>, id: string): IAssistanceCategoryObject => {
  for (const i in categories) {
    if (categories[i].id === id) {
      return categories[i]
    }
  }
  return { id, name: 'UNDEFINED' }
}

class MobilityOptionsList extends React.Component<IAssistanceItemProps, IStoreState> {
  constructor(props: IAssistanceItemProps) {
    super(props)
  }

  public render() {
    const { assistances, categories, onRemove } = this.props
    return (
      <div>
        <div className='flex pl3 mb1'>
          <div className='col-3'>
            <p className='h5 font-grey2'>Category</p>
          </div>
          <div className='col-3'>
            <p className='h5 font-grey2'>Type</p>
          </div>
          <div className='col-3'>
            <p className='h5 font-grey2'>Instruction</p>
          </div>
          <div className='col-3'>&nbsp;</div>
        </div>
        {assistances &&
          Object.keys(assistances).map((item, i) => (
            <AssistanceListItem
              key={`tmli-${i}`}
              onRemove={onRemove}
              category={getCategory(categories, assistances[item].categoryId)}
              assistance={assistances[item]}
            />
          ))}
      </div>
    )
  }
}

export default MobilityOptionsList



// WEBPACK FOOTER //
// ./src/components/assistance/AssistanceList.tsx